<template>
  <v-card>
    <v-card-title>
      <v-icon left>mdi-settings-transfer</v-icon>
      Parameters
      <v-spacer />
      <WorkOrderForm
        :is-duplicate="false"
        :is-edit="true"
        :instance="workorder"
        :projid="workorder.project_id"
      />
    </v-card-title>
    <v-list>
      <v-list-item>
        <v-list-item-icon><v-icon>mdi-scale</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ workorder.coatedquantity }}{{ workorder.units }}</v-list-item-title>
          <v-list-item-subtitle>Total Coated Material</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon><v-icon>fas fa-balance-scale-right</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ workorder.batchquantity }}{{ workorder.units }}</v-list-item-title>
          <v-list-item-subtitle>Batch Size</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon><v-icon>mdi-eye-outline</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ workorder.witnessquantity }}{{ workorder.units }}</v-list-item-title>
          <v-list-item-subtitle>Witness Quantity</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon><v-icon>fas fa-atom</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ workorder.coating.name }}</v-list-item-title>
          <v-list-item-subtitle>Chemistry</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-icon><v-icon>grain</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ workorder.material.name }}</v-list-item-title>
          <v-list-item-subtitle>Substrate</v-list-item-subtitle>
        </v-list-item-content>
        <v-list-item-action>
          <v-btn
            icon
            small
            :to="{ name: 'MaterialDetail', params: { id: workorder.material_id } }"
            target="_blank"
          >
            <v-icon small>fas fa-external-link-alt</v-icon>
          </v-btn>
        </v-list-item-action>
      </v-list-item>
    </v-list>
  </v-card>
</template>

<script>
import WorkOrder from "../../models/WorkOrder";
import WorkOrderForm from "./WorkOrderForm";
export default {
  name: "WorkOrderParameters",
  components: {WorkOrderForm},
  props: {
    workid: {
      type: [Number, String],
      required: true
    }
  },
  computed: {
    workorder() {
      return WorkOrder
        .query()
        .with("coating")
        .with("material")
        .find(parseInt(this.workid))
    }
  }
}
</script>
